import React from 'react';

import { FullPageBox } from '../../components/full-page-box/full-page-box';
import {
  SignInForm,
  type SignInNavigateDestination,
} from '../../components/sign-in-form/sign-in-form';

type Props = {
  onNavigate: (destination: SignInNavigateDestination) => Promise<void> | void;
};

const SignIn = ({ onNavigate }: Props) => {
  return (
    <FullPageBox width="400px">
      <SignInForm onNavigate={onNavigate} />
    </FullPageBox>
  );
};

export { SignIn };
